import React from 'react';
import { bool, func } from 'prop-types';

const CategoriesToggleButton = ({ isExpanded, toggleExpanded, hasMoreCategories }) => {
    if (!hasMoreCategories) {
        return null;
    }

    return (
        <div
            className={'categories-controls'}>
            <button
                className={`categories-toggle-btn ${isExpanded ? 'close-btn' : 'view-more-btn'}`}
                onClick={toggleExpanded}
                aria-label={isExpanded ? 'Show Less Categories' : 'Show More Categories'}
            >
                <span
                    className={'btn-text'}>
                    {isExpanded ? 'Show Less' : 'View More'}
                </span>
                <span
                    className={`btn-icon ${isExpanded ? 'icon-up' : 'icon-down'}`}>
                    {isExpanded ? '▲' : '▼'}
                </span>
            </button>
        </div>
    );
};

CategoriesToggleButton.propTypes = {
    isExpanded: bool.isRequired,
    toggleExpanded: func.isRequired,
    hasMoreCategories: bool.isRequired,
};

export default CategoriesToggleButton; 